<template>
    <div :class="['profile-sidebar', { 'open': isOpen }]">

        <div class="profile-header">
            <button @click="emit('close')" type="button" class="btn-close"></button>
            <h5 class="mb-0 ms-2">{{ isGroup ? 'Dados do Grupo' : 'Dados do contato' }}</h5>

            <button v-if="!isGroup" type="button" class="btn-edit" :class="{ 'active': isEditingContact }"
                @click="toggleEditContact" title="Editar Contato">
                <i :class="isEditingContact ? 'ri-close-line' : 'ri-pencil-fill'"></i>
            </button>
        </div>

        <Transition name="profile-fade" mode="out-in">

            <div class="profile-body" v-if="currentChat" :key="currentChat.id || 'content'">

                <div class="profile-avatar-top text-center">
                    <div class="avatar-wrapper" @click="openAvatarModal">
                        <AvatarField :foto="displayAvatar" :is-group="isGroup" class="avatar-xl rounded-circle mb-3" />
                        <div class="avatar-overlay">
                            <i class="ri-zoom-in-line"></i>
                        </div>
                    </div>

                    <div v-if="!isEditingContact">
                        <div v-if="currentChat.nomeClienteAxion" class="d-flex justify-content-center mb-1">
                            <span class="badge tag-badge text-truncate"
                                style="background-color: #4f46e520; color: #4f46e5; border-color: #4f46e5; max-width: 200px;"
                                :title="currentChat.nomeClienteAxion">
                                <i class="ri-vip-crown-fill me-1"></i>{{ currentChat.nomeClienteAxion }}
                            </span>
                        </div>
                        <h5 class="mb-1 text-truncate">{{ currentChat.name }}</h5>
                        <p v-if="!currentChat.isGroup && isInstagram" class="text-muted font-size-15 mb-0 mt-2">
                            <i class="ri-instagram-line me-1"></i>{{ instagramHandle(currentChat.name) }}
                        </p>
                        <p v-else-if="!currentChat.isGroup && isFacebook" class="text-muted font-size-15 mb-0 mt-2">
                            <i class="ri-messenger-line me-1"></i>Messenger
                        </p>
                        <p v-else-if="!currentChat.isGroup" class="text-muted font-size-15 mb-0 mt-2">{{
                            formatPhone(`${currentChat.codigoContato}`) }}</p>
                        <AiIntegrationToggle v-if="hasAiIntegration && !currentChat.isGroup" v-model="editForm.agenteIaAtivado" :read-only="true" :non-editable="true" label-position="hidden" :margin-bottom="false" />
                    </div>

                    <div v-else class="edit-contact-form-wrapper mt-3">
                        <div class="edit-card">
                            <div class="edit-card-header mb-3 d-flex align-items-center justify-content-between">
                                <span class="font-size-12 fw-bold text-uppercase text-muted letter-spacing-1">Editar Informações</span>
                                <button type="button" class="btn btn-sm btn-icon btn-light text-muted" @click="toggleEditContact" title="Cancelar">
                                    <i class="ri-close-line font-size-16"></i>
                                </button>
                            </div>

                            <div class="form-group mb-3 text-start">
                                <label class="input-label-mini">Nome do Contato</label>
                                <div class="input-box">
                                    <i class="ri-user-line box-icon text-secondary"></i>
                                    <input type="text" v-model="editForm.name" class="form-control modern-input ps-5" placeholder="Ex: Maria Silva">
                                </div>
                            </div>

                            <div class="form-group mb-4 text-start">
                                <template v-if="isInstagram">
                                    <label class="input-label-mini">Instagram</label>
                                    <div class="input-box flex-grow-1">
                                        <i class="ri-instagram-line box-icon text-secondary"></i>
                                        <input
                                            type="text"
                                            class="form-control modern-input ps-5"
                                            :value="instagramHandle(currentChat.name)"
                                            readonly
                                            disabled
                                        >
                                    </div>
                                    <small class="text-muted font-size-11 d-block mt-1">
                                        O identificador do Instagram não pode ser alterado.
                                    </small>
                                    <AiIntegrationToggle v-if="hasAiIntegration && !currentChat.isGroup" class="mt-2" v-model="editForm.agenteIaAtivado" label-position="left"/>
                                </template>
                                <template v-else>
                                <label class="input-label-mini">WhatsApp / Telefone</label>
                                <div class="d-flex gap-2">
                                    <div class="dropdown ddi-dropdown-wrapper">
                                        <button
                                            type="button"
                                            class="btn modern-input d-flex align-items-center justify-content-between w-100 h-100 px-2"
                                            data-bs-toggle="dropdown"
                                        >
                                            <span class="d-flex align-items-center gap-1 font-size-13">
                                                <img :src="`https://flagcdn.com/${selectedDdiObj.iso}.svg`" class="ddi-flag-img-sm" />
                                                <span class="fw-semibold text-dark">+{{ selectedDdiObj.code }}</span>
                                            </span>
                                            <i class="ri-arrow-down-s-line text-muted"></i>
                                        </button>

                                        <ul class="dropdown-menu shadow-xl border-0 custom-scrollbar custom-ddi-dropdown">
                                            <li v-for="ddi in ddiOptions" :key="ddi.code">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between py-2 px-3 transition-all"
                                                    @click="editForm.ddi = ddi.code; editForm.phone = maskPhone(editForm.phone, editForm.ddi)"
                                                >
                                                    <span class="d-flex align-items-center gap-2">
                                                        <img :src="`https://flagcdn.com/${ddi.iso}.svg`" class="ddi-flag-img-sm" />
                                                        <span class="font-size-13 fw-medium text-dark">{{ ddi.name }}</span>
                                                    </span>
                                                    <span class="font-size-11 text-muted fw-bold">+{{ ddi.code }}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="input-box flex-grow-1">
                                        <input
                                            type="tel"
                                            class="form-control modern-input"
                                            :value="editForm.phone"
                                            @input="editForm.phone = maskPhone(($event.target as HTMLInputElement).value, editForm.ddi)"
                                            placeholder="00000-0000"
                                        >
                                    </div>
                                </div>

                                <AiIntegrationToggle v-if="hasAiIntegration && !currentChat.isGroup" class="mt-2" v-model="editForm.agenteIaAtivado" label-position="left"/>
                                </template>
                            </div>


                            <button class="btn btn-save-modern w-100" @click="saveContactDetails" :disabled="isSavingContact">
                                <span v-if="isSavingContact" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                <i v-else class="ri-check-line me-1"></i>
                                {{ isSavingContact ? 'Salvando...' : 'Salvar Alterações' }}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="isGroup">
                    <!-- Comunidade: só aparece quando o grupo pertence a uma. O vínculo vem
                         resolvido na listagem (nome + foto), então não há busca aqui. -->
                    <div v-if="currentChat.comunidade" class="profile-card mb-3">
                        <div class="info-section">
                            <h6><i class="ri-group-2-line me-2"></i>Comunidade</h6>
                            <div class="d-flex align-items-center gap-2">
                                <div class="comunidade-mini-avatar">
                                    <img v-if="currentChat.comunidade.avatar && !comunidadeImagemFalhou"
                                        :src="currentChat.comunidade.avatar"
                                        :alt="currentChat.comunidade.nome"
                                        @error="comunidadeImagemFalhou = true" />
                                    <i v-else class="ri-group-2-fill"></i>
                                </div>
                                <div class="flex-grow-1 overflow-hidden">
                                    <p class="mb-0 font-size-14 text-truncate">{{ currentChat.comunidade.nome }}</p>
                                    <span class="text-muted font-size-11">Este grupo faz parte desta comunidade</span>
                                </div>
                                <button class="btn btn-sm btn-outline-primary flex-shrink-0"
                                    @click="abrirComunidade">
                                    Ver
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <h6><i class="ri-file-text-line me-2"></i>Descrição</h6>
                            <p class="text-dark mb-0 font-size-14" style="white-space: pre-wrap;">
                                {{ currentChat.description || 'Sem descrição definida.' }}
                            </p>
                        </div>
                    </div>

                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h6 class="mb-0">
                                    <i class="ri-group-line me-2"></i>Participantes
                                    <span class="badge bg-light text-dark ms-1">{{ participantesExibiveis.length }}</span>
                                </h6>
                            </div>

                            <div class="participants-list" style="max-height: 250px; overflow-y: auto;">
                                <div v-for="({ participante: part, principal, secundaria, numeroIndisponivel }, idx) in participantesComRotulos" :key="idx"
                                    class="d-flex align-items-center mb-3 pb-2">
                                    <div class="avatar-xs me-3 flex-shrink-0">
                                        <AvatarField :foto="part.avatar"
                                            class="avatar-title rounded-circle bg-primary-subtle text-primary font-size-12"
                                            style="width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;">
                                        </AvatarField>
                                    </div>
                                    <div class="flex-grow-1 overflow-hidden">
                                        <div class="participant-name-row">
                                            <h5 class="font-size-14 mb-0 text-truncate" :title="principal">{{ principal }}</h5>
                                            <span v-if="part.isAdmin"
                                                class="badge bg-success-subtle text-success font-size-10 flex-shrink-0">{{ part.isSuperAdmin ? 'Criador' : 'Admin' }}</span>
                                        </div>
                                        <p v-if="secundaria" class="participant-phone mb-0 text-truncate"
                                            :class="{ 'participant-phone-indisponivel': numeroIndisponivel }"
                                            :title="numeroIndisponivel ? 'O WhatsApp não revela o número deste participante.' : secundaria">
                                            {{ secundaria }}
                                        </p>
                                    </div>
                                </div>
                                <p v-if="participantesExibiveis.length === 0" class="text-muted font-size-13">
                                    {{ temParticipantesAnonimos
                                        ? 'Neste grupo o WhatsApp não revela os participantes.'
                                        : 'Nenhum participante carregado.' }}
                                </p>
                                <p v-else-if="temParticipantesAnonimos" class="text-muted font-size-11 mb-0">
                                    <i class="ri-information-line me-1"></i>
                                    Outros participantes existem, mas o WhatsApp não revela quem são neste grupo.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0"><i class="ri-price-tag-3-line me-2"></i>Etiquetas</h6>
                                <button class="btn btn-icon-sm"
                                    @click="() => { chatStore.setChatToLinkTags(currentChat!); uiStore.openLinkTagModal() }"
                                    title="Gerenciar etiquetas">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>

                            <div class="d-flex flex-wrap gap-2" v-if="currentChat.tags && currentChat.tags.length > 0">
                                <span v-for="tag in currentChat.tags" :key="tag.id" class="badge tag-badge"
                                    :style="{ backgroundColor: tag.cor + '20', color: tag.cor, borderColor: tag.cor }">
                                    {{ tag.nome }}
                                </span>
                            </div>
                            <p v-else class="text-muted font-size-13 mb-0">Nenhuma etiqueta atribuída.</p>
                        </div>
                    </div>

                    <div class="profile-card mb-3" v-permission="'conta.gerenciar_whitelist_grupos'">
                        <div class="info-section">
                            <div class="d-flex justify-content-between align-items-center">
                                <h6 class="mb-0">
                                    <i class="ri-chat-private-line me-2"></i>Grupo com conteúdo sensível
                                </h6>
                                <div class="form-check form-switch">
                                    <input class="form-check-input custom-switch" type="checkbox" v-model="currentChat.isWhitelistEnabled" @change="updateWhitelistStatus" :disabled="updatingWhitelistStatus" :class="{'disabled': updateWhitelistStatus}">
                                </div>
                            </div>

                            <template v-if="currentChat.isWhitelistEnabled">
                                <!-- Lista de atendentes -->
                                <div class="filter-dropdown-content custom-scrollbar">
                                    <h6 class="dropdown-header-v bg-transparent" style="font-size: 11px">
                                        Usuários permitidos (whitelist)
                                        <span class="badge bg-light text-dark ms-1">{{ currentChat.grupoWhitelist?.length || 0 }}</span>
                                    </h6>

                                    <div class="dropdown-item-v-check select-all-row">
                            <div class="form-check d-flex gap-2 align-items-center p-0 m-0">
                                <input
                                    class="form-check-input flex-shrink-0 m-0"
                                    type="checkbox"
                                    id="f-select-all-whitelist"
                                    :checked="isAllWhitelisted"
                                    :indeterminate.prop="isIndeterminateWhitelist"
                                    @click="toggleAllWhitelistedUsers"
                                >
                                <label class="form-check-label fw-semibold d-flex align-items-center gap-2 flex-grow-1 overflow-hidden ps-0" for="f-select-all-whitelist">
                                    Selecionar todos
                                </label>
                            </div>
                        </div>

                        <template v-for="(agent, i) in availableAgents" :key="i + agent.id">
                                        <div class="dropdown-item-v-check" style="max-height: 250px; overflow-y: auto;">
                                            <div class="form-check d-flex gap-2 align-items-center p-0 m-0">
                                                <input class="form-check-input flex-shrink-0 m-0" type="checkbox"
                                                    :value="agent.id" :id="`f-team-${agent.id}`"
                                                    @click="toggleWhitelistedUser(agent, !computedWhitelistMap.has(agent.id))"
                                                    :checked="computedWhitelistMap.has(agent.id)"
                                                    :disabled="loadingAgentIds.has(agent.id)"
                                                    :class="{'disabled': loadingAgentIds.has(agent.id)}"
                                                >
                                                <div class="tiny-avatar-container">
                                                    <img :src="agent.foto || branding.images.avatarFallback" class="rounded-circle tiny-avatar-img" alt="Avatar" loading="lazy">
                                                </div>
                                                <label class="form-check-label d-flex align-items-center gap-2 flex-grow-1 overflow-hidden ps-0" :for="agent.id == authStore.user?.id ? 'f-mine' : `f-team-${agent.id}`">
                                                    {{ agent.nome }}
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </div>

                            </template>
                        </div>
                    </div>
                </div>

                <div v-else>
                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <h6><i class="ri-user-star-line me-2"></i>Atendente Fixo nesse inbox</h6>

                            <div class="d-flex align-items-center justify-content-between" v-if="!isChangingAttendant">
                                <div class="d-flex align-items-center">
                                        <AvatarField :foto="atendenteFixo?.foto"
                                            class="avatar-sm rounded-circle me-3" />
                                        <div>
                                            <p class="text-muted mb-0 font-size-12">Atribuído a:</p>
                                            <span class="text-dark font-weight-600">{{ atendenteFixo?.nome || 'Ninguém' }}</span>
                                        </div>
                                </div>
                                <button @click="isChangingAttendant = true"
                                    class="btn btn-soft-primary btn-sm">{{ atendenteFixo ? 'Trocar' : 'Selecionar' }}</button>
                            </div>

                            <div v-else class="attendant-change-wrapper">
                                <select v-model="selectedAttendant" class="form-select form-select-sm mb-2">
                                    <option :value="null">Sem atendente</option>
                                    <option v-for="usuario in possiveisAtendentesFixos" :key="usuario.id" :value="usuario">
                                        {{ usuario.nome }}
                                    </option>
                                </select>
                                <div class="d-flex gap-2">
                                    <button class="btn btn-primary btn-sm flex-grow-1"
                                        @click="atribuirAtendenteFixo">Salvar</button>
                                    <button class="btn btn-light btn-sm"
                                        @click="isChangingAttendant = false">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0"><i class="ri-price-tag-3-line me-2"></i>Etiquetas</h6>
                                <button class="btn btn-icon-sm"
                                    @click="() => { chatStore.setChatToLinkTags(chatStore.activeChat!); uiStore.openLinkTagModal() }"
                                    title="Gerenciar etiquetas">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>

                            <div class="d-flex flex-wrap gap-2" v-if="currentChat.tags && currentChat.tags.length > 0">
                                <span v-for="tag in currentChat.tags" :key="tag.id" class="badge tag-badge"
                                    :style="{ backgroundColor: tag.cor + '20', color: tag.cor, borderColor: tag.cor }">
                                    {{ tag.nome }}
                                </span>
                            </div>
                            <p v-else class="text-muted font-size-13 mb-0">Nenhuma etiqueta atribuída.</p>
                        </div>
                    </div>

                    <div class="profile-card mb-3">
                        <div class="info-section">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="mb-0"><i class="ri-pencil-ruler-2-line me-2"></i>Observações</h6>

                                <button v-if="!isEditingObservation && localObservation"
                                    class="btn btn-sm p-0 font-weight-bold btn-soft-primary p-1" style="font-size: 0.8rem;"
                                    @click="isEditingObservation = true">
                                    Editar observação
                                </button>
                            </div>

                            <div v-if="!isEditingObservation">
                                <div v-if="localObservation" class="observation-view">
                                    {{ localObservation }}
                                </div>
                                <div v-else class="text-center py-3">
                                    <p class="text-muted font-size-13 mb-2">Nenhuma observação.</p>
                                    <button class="btn btn-soft-primary btn-sm w-100" @click="isEditingObservation = true">
                                        Adicionar observação
                                    </button>
                                </div>
                            </div>

                            <div v-else>
                                <textarea v-model="localObservation" class="form-control obs-textarea" rows="3"
                                    placeholder="Escreva uma observação..." maxlength="300" ref="obsInputRef"></textarea>
                                <div class="d-flex justify-content-between align-items-center mt-2 gap-2">
                                    <small class="text-muted">{{ localObservation.length }} / 300</small>
                                    <div class="d-flex gap-2">
                                        <button type="button" class="btn btn-light btn-sm" @click="cancelEditObservation">
                                            Cancelar
                                        </button>
                                        <button type="button" class="btn btn-primary btn-sm" @click="handleSaveObservation">
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="profile-card media-card">
                    <div class="info-section p-0">
                        <ul class="nav nav-tabs nav-tabs-profile" role="tablist">
                            <li class="nav-item flex-fill text-center">
                                <a class="nav-link active" data-bs-toggle="tab" href="#profile-media" role="tab">
                                    Mídia <span class="badge bg-light text-dark ms-1">{{ mediaList.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item flex-fill text-center">
                                <a class="nav-link" data-bs-toggle="tab" href="#profile-docs" role="tab">
                                    Docs <span class="badge bg-light text-dark ms-1">{{ docList.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item flex-fill text-center">
                                <a class="nav-link" data-bs-toggle="tab" href="#profile-links" role="tab">
                                    Links <span class="badge bg-light text-dark ms-1">{{ linkList.length }}</span>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content p-3 tab-content-scrollable">

                            <div class="tab-pane active" id="profile-media">
                                <div v-if="mediaList.length > 0" class="media-grid">
                                    <div v-for="msg in mediaList" :key="msg.id" class="media-item"
                                        @click="openMedia(msg)">
                                        <img :src="msg.fileData?.url" v-if="isImage(msg)" />
                                        <div v-else-if="isVideo(msg)" class="video-placeholder">
                                            <VideoDeChat :src="msg.fileData?.url" preload="metadata"></VideoDeChat>
                                            <div class="video-play-overlay"><i class="ri-play-fill"></i></div>
                                        </div>
                                    </div>
                                </div>
                                <p v-else class="text-muted text-center font-size-13 py-3">Sem mídia.</p>
                            </div>

                            <div class="tab-pane" id="profile-docs">
                                <div v-if="docList.length > 0" class="docs-list">
                                    <div v-for="msg in docList" :key="msg.id" class="doc-item">
                                        <div class="doc-icon"><i class="ri-file-text-fill"></i></div>
                                        <div class="doc-info text-truncate">
                                            <span class="d-block text-truncate fw-bold font-size-13">{{ msg.fileData?.name
                                                }}</span>
                                            <span class="text-muted font-size-11">{{ msg.fileData?.size }} • {{ msg.time
                                                }}</span>
                                        </div>
                                        <a :href="msg.fileData?.url" download class="doc-download"><i
                                                class="ri-download-2-line"></i></a>
                                    </div>
                                </div>
                                <p v-else class="text-muted text-center font-size-13 py-3">Sem documentos.</p>
                            </div>

                            <div class="tab-pane" id="profile-links">
                                <div v-if="linkList.length > 0" class="links-list">
                                    <div v-for="(link, i) in linkList" :key="i" class="link-item">
                                        <div class="link-icon"><i class="ri-link"></i></div>
                                        <div class="link-info text-truncate">
                                            <a :href="link.url" target="_blank"
                                                class="d-block text-truncate font-size-13">{{ link.url
                                                }}</a>
                                            <span class="text-muted font-size-11">Mensagem enviada em {{ link.date }}</span>
                                        </div>
                                    </div>
                                </div>
                                <p v-else class="text-muted text-center font-size-13 py-3">Sem links.</p>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- <div class="profile-card">
                    <div class="accordion accordion-flush" id="favoritesAccordion">
                        <div class="accordion-item">

                            <h2 class="accordion-header rounded" id="favorites-heading">
                                <button
                                    class="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#favorites-collapse"
                                    aria-expanded="false"
                                    aria-controls="favorites-collapse"
                                >
                                    <i class="ri-star-line me-2"></i>
                                    Mensagens Favoritas
                                    <span class="badge bg-secondary rounded-pill ms-2">{{ favoritedMessages.length }}</span>
                                </button>
                            </h2>

                            <div
                                id="favorites-collapse"
                                class="accordion-collapse collapse"
                                aria-labelledby="favorites-heading"
                                data-bs-parent="#favoritesAccordion"
                            >
                                <div class="accordion-body p-0">
                                    <div class="favorites-list">

                                        <div v-if="favoritedMessages.length === 0" class="empty-favorites">
                                            <p>Nenhuma mensagem favorita neste chat.</p>
                                        </div>

                                        <div
                                            v-for="msg in favoritedMessages"
                                            :key="msg.id"
                                            class="favorite-message-item"
                                            @click="handleFavoriteClick(msg)"
                                        >
                                            <span class="sender-name" :class="msg.isSent ? 'you' : 'contact'">
                                                {{ msg.isSent ? 'Você' : (contact.name || 'Contato') }}
                                            </span>

                                            <p v-if="msg.text" class="mb-0 snippet">{{ msg.text }}</p>
                                            <p v-if="msg.type === 'audio'" class="mb-0 snippet">
                                                <i class="ri-mic-line"></i> Áudio
                                            </p>
                                            <p v-if="msg.type === 'list'" class="mb-0 snippet">
                                                <i class="ri-list-check"></i> {{ msg.listHeader || 'Lista' }}
                                            </p>

                                            <span class="timestamp">{{ msg.time }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div v-if="!isGroup"  class="mt-auto pt-3">
                    <button @click="showHistoricoForContact()"
                        class="btn btn-primary btn-sm w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                        style="font-size: 0.9rem;">
                        <i class="ri-file-list-3-line"></i> Ver Atendimentos
                    </button>
                </div>

            </div>

            <div
                class="profile-body d-flex align-items-center justify-content-center"
                v-else
                key="loading"
            >
                <div class="spinner-border text-primary" role="status"></div>
            </div>


        </Transition>

        <ComunidadeModal ref="comunidadeModalRef" />
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch, nextTick, PropType } from 'vue';
import VideoDeChat from './VideoDeChat.vue';
import { branding } from '@/config/branding';
import AvatarField from '@/components/global/AvatarField.vue';
import ComunidadeModal from '@/components/app/modals/ComunidadeModal.vue';
import { useUiStore } from '@/stores/app/uiStore';
import { useChatStore } from '@/stores/app/chatStore';
import { toast } from 'vue3-toastify';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { Atendente, Chat, Message } from '@/mocks/app/mockChatData';
import { formatPhone, normalizarPhone } from '@/utils/phone';
import { rotulosDoParticipante, telefoneDoParticipante } from '@/utils/participanteGrupo';
import { IdAtendimento, IdGrupo, IdInbox, IdUsuario } from '@/services/common-types';
import { MensagensService } from '@/services/mensagens/mensagens.service';
import { WhizMessagesToMessagesWithReaction } from '@/stores/app/chatUtils';
import { ResponseUsuario, UsuariosService } from '../../../../services/usuarios/usuarios.service';
import { useContatoStore } from '../../../../stores/app/contatoStore';
import { standardizePhone } from '@/utils/phone';
import { UsuariosContaAtual } from '@/utils/usuarios-conta-atual.composable';
import { ddiOptions } from '@/utils/countries';
import Swal from 'sweetalert2';
import AiIntegrationToggle from '@/components/switch/AiIntegrationToggle.vue';
import { cHasAiIntegration } from '@/composables/hasAiIntegration';
import { isInstagramContato, isFacebookContato, instagramHandle } from '@/utils/instagram-contato';
import { ResponseContato } from '@/services/contatos/contatos';
import { reagirAoResultadoDaFoto } from '@/utils/fotoDeContato';
import { abrirConversaDoContatoDuplicado, avisarContatoDuplicado, numeroMudou } from '@/utils/contatoDuplicado';

const props = defineProps({
    isOpen: { type: Boolean, default: false },
    chat: { type: Object as PropType<Chat>, default: null }
});

const emit = defineEmits(['close']);
const uiStore = useUiStore();
const chatStore = useChatStore();
const authStore = useAuthStoreUser();
const contatoStore = useContatoStore();

const userService = new UsuariosService();

const { __debugForceHasAiIntegration, hasAiIntegration } = cHasAiIntegration(authStore);

// --- LÓGICA DE SELEÇÃO DE CHAT ---
const currentChat = computed(() => chatStore.tempProfileChat || props.chat);

const comunidadeModalRef = ref<{ abrir: (idGrupo: IdGrupo) => void } | null>(null);
/** A foto da comunidade vem de URL da plataforma e pode expirar. */
const comunidadeImagemFalhou = ref(false);
// Sem reset, uma foto quebrada na comunidade A deixava o ícone de fallback ligado ao
// abrir um grupo da comunidade B, cuja foto está boa.
watch(() => currentChat.value?.comunidade?.id, () => { comunidadeImagemFalhou.value = false; });

/**
 * Participantes que dão para identificar.
 *
 * No subgrupo de avisos de uma comunidade o WhatsApp esconde os membros comuns: chega
 * só um LID, sem telefone e sem nome. Listá-los rendia linhas com dígitos crus no
 * lugar do nome — informação zero e visualmente ruim. Some da lista; a existência
 * deles é dita em uma frase.
 */
const participantesExibiveis = computed(
    () => (currentChat.value?.participants ?? []).filter(p => !p.isAnonymous),
);

/** Nome em destaque e telefone embaixo — ou o aviso, quando a plataforma não o revelou. */
const participantesComRotulos = computed(() => participantesExibiveis.value.map(participante => ({
    participante,
    ...rotulosDoParticipante(participante),
    numeroIndisponivel: !telefoneDoParticipante(participante),
})));

const temParticipantesAnonimos = computed(
    () => (currentChat.value?.participants ?? []).some(p => p.isAnonymous),
);

function abrirComunidade() {
    const id = currentChat.value?.id;
    if (!id) return;
    // O modal busca pelo id do GRUPO, não da comunidade: é o grupo que determina a
    // inbox, e a visão da comunidade é escopada por inbox.
    comunidadeModalRef.value?.abrir(id as IdGrupo);
}

// Contato resolvido (para descobrir o tipo — INSTAGRAM tem regras próprias)
const currentContato = computed(() =>
    currentChat.value?.idContato
        ? chatStore.contatosById.get(currentChat.value.idContato) ?? null
        : null
);
// INSTAGRAM se o tipo do contato OU a plataforma do inbox indicar (contato pode não estar no cache)
const isInstagram = computed(() => {
    if (isInstagramContato(currentContato.value?.tipo)) return true;
    const idInbox = currentChat.value?.idInbox;
    if (!idInbox) return false;
    const plataforma = chatStore.inboxMap.get(idInbox)?.plataforma;
    return plataforma === 'INSTAGRAM_META' || plataforma === 'INSTAGRAM_LOGIN';
});
// FACEBOOK/Messenger: pelo tipo do contato OU pela plataforma do inbox.
const isFacebook = computed(() => {
    if (isFacebookContato(currentContato.value?.tipo)) return true;
    const idInbox = currentChat.value?.idInbox;
    if (!idInbox) return false;
    const p = chatStore.inboxMap.get(idInbox)?.plataforma;
    return p === 'FACEBOOK' || p === 'MESSENGER_META';
});

const possiveisAtendentesFixos = ref<ResponseUsuario[]>([]);

// --- ESTADOS LOCAIS ---
const isEditingContact = ref(false);
const editForm = ref({ name: '', ddi: '55', phone: '', agenteIaAtivado: false });
const isSavingContact = ref(false);
const selectedDdiObj = computed(() => ddiOptions.find(d => d.code === editForm.value.ddi) || ddiOptions[0]);

const isChangingAttendant = ref(false);
const selectedAttendant = ref<Atendente | null>(null);

const atendenteFixo = ref<ResponseUsuario | null>(null);

const localObservation = ref('');
const originalObservation = ref('');
const isEditingObservation = ref(false);
const obsInputRef = ref<null | HTMLTextAreaElement>(null);

// --- ESTADO PARA MENSAGENS DO SIDEBAR ---
const sidebarMessages = ref<Message[]>([]);
const isLoadingSidebarMedia = ref(false);

// --- COMPUTEDS DE MÍDIA ---
const messages = computed(() => {
    if (chatStore.activeChat && currentChat.value?.id === chatStore.activeChat.id) {
        return chatStore.messages;
    }
    return sidebarMessages.value;
});

const mediaList = computed(() => {
    return messages.value.filter(m => {
        if (m.fileData?.mimeType?.startsWith('image/')) return true;
        if (m.fileData?.mimeType?.startsWith('video/')) return true;
        return false;
    }).reverse();
});

const docList = computed(() => {
    return messages.value.filter(m => m.type === 'file' && !m.fileData?.mimeType.startsWith('image/'));
});

const linkList = computed(() => {
    const links = [] as { url: string, date: string }[];
    messages.value.filter(m => m.type === 'text').forEach(m => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const found = m.text?.match(urlRegex);
        if (found) {
            found.forEach(url => links.push({ url, date: m.time }));
        }
    });
    return links;
});

const isGroup = computed(() => {
    const c = currentChat.value;
    return c?.isGroup === true ||
        (c?.id && c.id.toString().includes('@g.us')) ||
        c?.id === 'g1';
});

function maskPhone(val: string, ddi: string) {
    if (!val) return '';
    let raw = val.replace(/\D/g, ''); // Remove tudo que não for número

    // Dicionário de máscaras e limites por país
    const masks: Record<string, { pattern: string, limit: number }> = {
        '55': { pattern: raw.length <= 10 ? '(##) ####-####' : '(##) #####-####', limit: 11 }, // Brasil
        '1':  { pattern: '(###) ###-####', limit: 10 }, // EUA/Canadá
        '351':{ pattern: '### ### ###', limit: 9 },   // Portugal
        '54': { pattern: '# ####-####', limit: 10 },  // Argentina
        '56': { pattern: '# #### ####', limit: 9 },   // Chile
        '57': { pattern: '### ### ####', limit: 10 }, // Colômbia
        '52': { pattern: '### ### ####', limit: 10 }, // México
        '51': { pattern: '### ### ###', limit: 9 },   // Peru
        '598':{ pattern: '## ### ###', limit: 8 },    // Uruguai
        '58': { pattern: '###-###-####', limit: 10 }, // Venezuela
        '34': { pattern: '### ## ## ##', limit: 9 },  // Espanha
        '39': { pattern: '### #######', limit: 10 },  // Itália
        '33': { pattern: '# ## ## ## ##', limit: 9 }, // França
        '44': { pattern: '#### ######', limit: 10 },  // Reino Unido
        '49': { pattern: '#### #######', limit: 11 }, // Alemanha
    };

    const config = masks[ddi] || { pattern: '################', limit: 15 }; // Padrão caso o DDI não esteja na lista

    // Trava o tamanho máximo permitido para o país
    raw = raw.substring(0, config.limit);

    if (config.pattern === '################') return raw;

    let formatted = '';
    let rawIndex = 0;

    for (let i = 0; i < config.pattern.length && rawIndex < raw.length; i++) {
        if (config.pattern[i] === '#') {
            formatted += raw[rawIndex++];
        } else {
            formatted += config.pattern[i];
        }
    }

    // Retira qualquer caractere de formatação que fique sobrando no final (ex: se apagar um número e sobrar o hífen)
    return formatted.replace(/[^0-9]+$/, '');
}

// --- WATCHERS ---
watch(() => currentChat.value.id, async (newChatId) => {
    const newChat = currentChat.value as Chat & { contato?: ResponseContato };
    if (newChat) {
        console.log("🔹 [Sidebar] Perfil aberto:", newChat.name, "| ID Contato:", newChat.idContato, "| Código:", newChat.codigoContato);

        isEditingContact.value = false;
        isChangingAttendant.value = false;
        isEditingObservation.value = false;

        localObservation.value = newChat.obsContato || '';
        originalObservation.value = localObservation.value;

        let phoneStr = newChat.codigoContato || '';
        let foundDdi = '55'; // padrão

        const sortedDdis = [...ddiOptions].sort((a, b) => b.code.length - a.code.length);
        for (const ddi of sortedDdis) {
            if (phoneStr.startsWith(ddi.code)) {
                if (ddi.code === '55' && phoneStr.length <= 11) continue;
                foundDdi = ddi.code;
                phoneStr = phoneStr.substring(ddi.code.length);
                break;
            }
        }
        
        const foundContato = newChat.contato;
        console.log('[foundContato]', newChat.idContato, foundContato);

        editForm.value = {
            name: newChat.name,
            ddi: foundDdi,
            phone: maskPhone(phoneStr, foundDdi),
            agenteIaAtivado: foundContato?.agenteIaAtivado || false
        };

        selectedAttendant.value = newChat.atendentes?.at(0) || null;

        const isActiveChatDifferent = chatStore.activeChat?.id !== newChat.id;

        if (isActiveChatDifferent) {
            isLoadingSidebarMedia.value = true;
            sidebarMessages.value = [];

            try {
                if (!newChat.idContato && newChat.codigoContato) {
                    console.log("🔍 [Sidebar] Buscando contato pelo telefone:", newChat.codigoContato);

                    const resolved = await chatStore.findOrMakeContatoByPhone(newChat.codigoContato);

                    if (resolved) {
                        console.log("✅ [Sidebar] Contato resolvido:", resolved.id);
                        newChat.idContato = resolved.id;
                    }
                }

                const msgService = new MensagensService();
                let rawMessages;

                if (newChat.idContato && newChat.idInbox) {
                    rawMessages = await msgService.getMensagensCrossAtendimentoByInboxContato(
                        newChat.idContato,
                        newChat.idInbox,
                        undefined,
                        50
                    );
                }
                else if (newChat.id && !String(newChat.id).startsWith('temp_') && !String(newChat.id).startsWith('g')) {
                    rawMessages = await msgService.getMensagensByAtendimento(newChat.id as IdAtendimento, 1, 50);
                }

                if (rawMessages) {
                    const parsed = WhizMessagesToMessagesWithReaction(rawMessages);
                    sidebarMessages.value = parsed.reverse();
                }
            } catch (e) {
                console.error("❌ [Sidebar] Erro ao carregar dados do perfil:", e);
            } finally {
                isLoadingSidebarMedia.value = false;
            }
        } else {
            sidebarMessages.value = [];
        }

        atendenteFixo.value = await contatoStore.buscarAtendenteFixo(currentChat.value.idContato!, currentChat.value.idInbox) ?? null;
        await UpdateAtendentesForActiveChatInbox(newChat.idInbox);
    }
}, { immediate: true });

watch(() => props.isOpen, (val) => {
    if (!val) {
        setTimeout(() => {
            chatStore.closeProfile();
            sidebarMessages.value = [];
        }, 300);
    }
});

// --- AÇÕES ---
const atribuindoAtendente = ref(false);

async function removerAtendenteFixo() {
  const dto = {
    idContato: currentChat.value.idContato,
    idInbox: currentChat.value.idInbox
  };

  await contatoStore.removerAtendenteFixo(dto.idContato!, dto.idInbox);

  toast.success('Atendente fixo removido');

  atendenteFixo.value = null;

  isChangingAttendant.value = false;
  atribuindoAtendente.value = false;

}

async function atribuirAtendenteFixo() {
  if (atribuindoAtendente.value) return;

  atribuindoAtendente.value = true;

  if (!selectedAttendant.value) return removerAtendenteFixo();

  const dto = {
    idContato: currentChat.value.idContato,
    idAtendente: selectedAttendant.value?.id,
    idInbox: currentChat.value.idInbox
  };

  atendenteFixo.value = await contatoStore.atribuirAtendenteFixo(dto.idContato!, dto.idAtendente!, dto.idInbox);

  toast.success('Atendente fixo salvo');

  isChangingAttendant.value = false;
  atribuindoAtendente.value = false;
}

async function UpdateAtendentesForActiveChatInbox(idInbox?: IdInbox|null) {
    possiveisAtendentesFixos.value = idInbox ? await userService.getByInbox(idInbox) : []
}

function showHistoricoForContact() {
    if (!currentChat.value) return;
    chatStore.focusedContactIdForHistory = currentChat.value.idContato;
    uiStore.openAttendanceReportModal();
}

function toggleEditContact() {
    if (isEditingContact.value && currentChat.value) {
        editForm.value.name = currentChat.value.name;
    }
    isEditingContact.value = !isEditingContact.value;
}

async function saveContactDetails() {
    if (isSavingContact.value) return;

    const c = currentChat.value;
    if (!c?.idContato) throw new Error('[ChatProfileSidebar] [saveContactDetails] ID de contato não disponível.');

    const contextId = c.id;

    let rawPhone = editForm.value.phone.replace(/\D/g, '');
    let finalPhone = normalizarPhone( editForm.value.ddi + rawPhone );
    // INSTAGRAM: o código (id do Instagram) é imutável — preserva o original.
    let finalCodigo: string;
    if (isInstagram.value) {
        finalCodigo = c.codigoContato ?? '';
    } else {
        const rawPhone = editForm.value.phone.replace(/\D/g, '');
        finalCodigo = normalizarPhone(editForm.value.ddi + rawPhone);
    }

    isSavingContact.value = true;
    try {
        const idConta = authStore.currentConta?.id;
        if (idConta && !isInstagram.value && !isFacebook.value && numeroMudou(c.codigoContato, finalCodigo)) {
            const dono = await contatoStore.buscarOutroContatoComCodigo(idConta, c.idContato, finalCodigo);
            if (dono) {
                isSavingContact.value = false;
                // Edição continua aberta para o operador corrigir o número, se preferir.
                if (await avisarContatoDuplicado(dono)) void abrirConversaDoContatoDuplicado(dono);
                return;
            }
        }

        await chatStore.updateContactDetails({
            id: c.idContato,
            nome: editForm.value.name,
            codigo: finalCodigo,
            agenteIaAtivado: editForm.value.agenteIaAtivado
        }, contextId);

        isEditingContact.value = false;
        toast.success('Contato atualizado!');
    } finally {
        isSavingContact.value = false;
    }
}

const displayAvatar = computed(() => {
    const c = currentChat.value;
    if (!c) return null;

    if (c.avatar && c.avatar.length > 5) {
        return c.avatar;
    }

    return isGroup.value ? branding.images.avatarFallbackGroup : branding.images.avatarFallback;
});

async function openAvatarModal() {
    if (isGroup.value) {
        uiStore.openMediaViewer(displayAvatar.value || branding.images.avatarFallbackGroup, 'image', currentChat.value?.name || 'Grupo');
        return;
    }

    const result = await Swal.fire({
        title: 'Foto do contato',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Buscar no WhatsApp',
        denyButtonText: 'Ver foto atual',
        cancelButtonText: 'Fechar',
        confirmButtonColor: '#25d366',
        html: '<span style="font-size:13px;color:#6c757d;">⚠️ Buscar a foto do WhatsApp pode resultar no <strong>banimento do número</strong>. Use com responsabilidade.</span>',
    });

    if (result.isConfirmed) {
        const c = currentChat.value;
        if (!c?.codigoContato || !c?.idContato) return;
        const idConta = authStore.currentConta?.id;
        if (!idConta) return;
        try {
            const resultado = await contatoStore.buscarFotoPerfil(c.idContato, c.codigoContato, idConta);
            await reagirAoResultadoDaFoto(resultado);
        } catch (e) {
            toast.error((e as Error).message || 'Erro ao buscar foto.');
        }
    } else if (result.isDenied) {
        uiStore.openMediaViewer(displayAvatar.value || branding.images.avatarFallback, 'image', currentChat.value?.name || 'Contato');
    }
}

async function transferirAtendimento() {
    const c = currentChat.value;
    if (!c) return;
    if (selectedAttendant.value) {
        if (!c.idContato) throw new Error('[ChatProfileSidebar] [transferirAtendimento] `chat.idContato` was `undefined`.');

        await chatStore.transferirAtendimento(
            c.id as IdAtendimento,
            selectedAttendant.value.id,
            c.idContato,
            c.idInbox,
            {
                enviarMensagemTransferencia: false,
                finalizarAtendimento: false,
                idCanal: null
            }
        );

        isChangingAttendant.value = false;
        toast.success(`Atendente alterado para ${selectedAttendant.value.name}!`);
    } else {
        await chatStore.removerAtendentesAtendimento(c);
        isChangingAttendant.value = false;
        toast.success(`Atendente removido!`);
    }
}

async function handleSaveObservation() {
    const c = currentChat.value;
    if (!c?.idContato) throw new Error('[ChatProfileSidebar] [handleSaveObservation] Nenhum ID de contato informado.');

    const contextId = c.id;

    await chatStore.updateContactDetails({
        id: c.idContato,
        observacao: localObservation.value
    }, contextId);

    originalObservation.value = localObservation.value;
    isEditingObservation.value = false;
    toast.success('Observação salva.');
}

function cancelEditObservation() {
    localObservation.value = originalObservation.value;
    isEditingObservation.value = false;
}

watch(isEditingObservation, (val) => {
    if (val) {
        nextTick(() => obsInputRef.value?.focus());
    }
});

// Keep editForm in sync when tempProfileChat is refreshed in background
watch(() => chatStore.tempProfileChat?.name, (freshName) => {
    if (freshName && chatStore.tempProfileChat) {
        editForm.value.name = freshName;
        localObservation.value = chatStore.tempProfileChat.obsContato || '';
        originalObservation.value = localObservation.value;
    }
});

const isImage = (msg: Message) => msg.fileData?.mimeType?.startsWith('image/');
const isVideo = (msg: Message) => msg.fileData?.mimeType?.startsWith('video/');

const openMedia = (msg: Message) => {
    if (isImage(msg)) {
        uiStore.openMediaViewer(msg.fileData?.url ?? 'media-file-url', 'image', msg.fileData?.caption);
    } else if (isVideo(msg)) {
        uiStore.openMediaViewer(msg.fileData?.url ?? 'media-file-url', 'video', msg.fileData?.caption);
    }
};

// #region Whitelist
const updatingWhitelistStatus = ref(false);
async function updateWhitelistStatus(evt: Event) {
    if (updatingWhitelistStatus.value) return;
    const newStatus = (evt.target as HTMLInputElement)?.checked;
    const storedStatus = !newStatus;
    updatingWhitelistStatus.value = true;
    try {
        await chatStore.updateGroupWhitelistStatus(props.chat.id as IdGrupo, newStatus);
    } catch (e) {
        currentChat.value.isWhitelistEnabled = storedStatus;
        toast.error((e as Error).message || `Não foi possível atualizar o status da whitelist do grupo.`);
    }
    updatingWhitelistStatus.value = false;
}

const _availableAgents = UsuariosContaAtual();
const availableAgents = computed(() => _availableAgents.value);
const computedWhitelistMap = computed(() => new Map(props.chat.grupoWhitelist?.map(u => [u.id, true]) ?? []))
const loadingAgentIds = ref(new Set<IdUsuario>());

const isAllWhitelisted = computed(() => {
    if (!availableAgents.value.length) return false;
    return availableAgents.value.every(a => computedWhitelistMap.value.has(a.id));
});

const isIndeterminateWhitelist = computed(() => {
    if (!availableAgents.value.length) return false;
    const count = availableAgents.value.filter(a => computedWhitelistMap.value.has(a.id)).length;
    return count > 0 && count < availableAgents.value.length;
});

async function toggleAllWhitelistedUsers() {
    const addAll = !isAllWhitelisted.value;
    const snapshot = computedWhitelistMap.value;
    const toProcess = availableAgents.value.filter(agent => addAll !== snapshot.has(agent.id));
    for (const agent of toProcess) {
        await toggleWhitelistedUser(agent, addAll);
    }
}

async function toggleWhitelistedUser(user: ResponseUsuario, addToWhitelist: boolean) {
    if (loadingAgentIds.value.has(user.id)) return;
    loadingAgentIds.value = new Set([...loadingAgentIds.value, user.id]);
    try {
        const idGrupo = props.chat.id as IdGrupo;
        if (addToWhitelist) {
            await chatStore.addUserToGroupWhitelist(idGrupo, user.id, user)
        } else {
            await chatStore.removeUserFromGroupWhitelist(idGrupo, user.id)
        }
    } catch (e) {
        console.error(e);
        toast.error((e as Error).message || `Não foi possível adicionar o usuário "${user.nome}" (#${user.id}) à whitelist.`);
    }
    const next = new Set(loadingAgentIds.value);
    next.delete(user.id);
    loadingAgentIds.value = next;
}
</script>


<style scoped>
/* Cantos arredondados, não círculo: é como a comunidade se distingue de um grupo na
   própria interface do WhatsApp. */
.comunidade-mini-avatar {
    width: 36px;
    height: 36px;
    border-radius: 11px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bs-light);
    color: #6c757d;
}

.comunidade-mini-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

[data-bs-theme=dark] .comunidade-mini-avatar {
    background-color: rgba(255, 255, 255, 0.06);
}

.btn-primary {
    background: var(--bs-light);
    color: var(--bs-dark);
    font-weight: bold;
    border-radius: 0.3rem
}

.btn-primary:hover {
    background: var(--bs-orange);
    color: #fff;
    font-weight: bold;
}

.btn-soft-primary {
    background: var(--bs-light);
    color: var(--bs-dark);
    font-weight: bold;
    border-radius: 0.3rem
}

.btn-soft-primary:hover {
    background: rgba(var(--bs-primary-rgb), 0.44);
    color: #fff;
    font-weight: bold;
}

.profile-sidebar {
    width: 0;
    height: 100vh;
    background-color: var(--bs-white);
    background-image: var(--brand-profile-sidebar-gradient);
    z-index: 10;
    transition: width 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: hidden;
    box-shadow: 0px 0rem 1rem 0px rgb(0 0 0 / 7%);
}

.profile-sidebar.open {
    width: 450px;
}

@media (max-width: 992px) {

    .profile-sidebar {
        position: fixed;
        top: 0;
        right: -100%;
        width: 100%;
        z-index: 1040;
        transition: right 0.3s ease-in-out;
        border-left: none;
    }

    .profile-sidebar.open {
        right: 0;
        width: 100%;
    }
}

/* --- Cabeçalho --- */
.profile-header {
    justify-content: space-between;
    display: flex;
    align-items: center;
    padding: 1rem 1.5rem;
    flex-shrink: 0;
}

/* Corrigindo para tema escuro */
[data-bs-theme=dark] .profile-header {
    background-color: var(--bs-body-tertiary);
}

.profile-header h5 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0;
}

.btn-close {
    border: none;
    font-size: 1.5rem;
    opacity: 0.7;
    padding: 0;
}

.btn-edit {
    font-size: 1.2rem;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    transition: all 0.2s ease-in-out;
}

.btn-edit:hover {
    background-color: var(--bs-dark-bg-subtle);
}

.btn-close:hover {
    opacity: 1;
}

/* --- Corpo e Seções --- */
.profile-body {
    overflow-y: auto;
    flex-grow: 1;
    /* ⭐ MELHORIA: Padding e Gap para os cards */
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    /* Espaçamento entre os cards */
}

.profile-body {
    scrollbar-width: thin;
    scrollbar-color: var(--bs-light) transparent;
}

.profile-body::-webkit-scrollbar {
    width: 8px;
}

.profile-body::-webkit-scrollbar-track {
    background: transparent;
}

.profile-body::-webkit-scrollbar-thumb {
    background-color: var(--bs-light);
    border-radius: 10px;
    border: 2px solid var(--bs-white);
}


.profile-card {
    background-color: var(--bs-body-tertiary);
    border-radius: var(--bs-border-radius-lg);
    box-shadow: inset 1px 0rem 1rem 0px rgb(0 0 0 / 9%);
    border-radius: 1rem !important;
}

/* No tema claro, usamos um fundo branco para os cards */
[data-bs-theme=light] .profile-card {
    background-color: var(--bs-white);
}

/* Participante do grupo: nome e selo na mesma linha, telefone como informação
   secundária. `min-width: 0` é o que deixa o nome longo truncar em vez de empurrar o selo. */
.participant-name-row {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}
.participant-name-row h5 {
    min-width: 0;
}
.participant-phone {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.3;
    color: var(--bs-secondary-color);
    font-variant-numeric: tabular-nums;
}
.participant-phone-indisponivel {
    font-style: italic;
    opacity: 0.8;
}

/* Ajustes no topo do avatar */
.profile-avatar-top {
    padding: 0;
    /* Padding agora é controlado pelo .profile-body */
}

.profile-avatar-top .avatar-xl {
    width: 100px;
    /* Reduzido de 120px */
    height: 100px;
    /* Reduzido de 120px */
    font-size: 3rem;
}

.profile-avatar-top h5 {
    font-weight: 600;
    font-size: 1.25rem;
    color: var(--bs-dark);
}

.profile-avatar-top p {
    font-weight: 500;
}

.info-section {
    padding: 1.25rem;
}

.info-section:last-child {
    border-bottom: none;
}

.profile-card .info-section+.info-section {
    padding-top: 0;
}


.info-section h6 {
    font-weight: 500;
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    color: var(--bs-text-muted);
}

.info-section h6 i {
    font-size: 1.1rem;
    margin-right: 0.75rem;
    color: var(--bs-text-muted);
}

.badge {
    padding: 6px 10px;
    font-size: 12px;
}

.nav-tabs-profile .nav-link {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
    color: var(--bs-text-muted);
    border: none;
}

.nav-tabs-profile .nav-link.active {
    color: var(--bs-primary);
    background-color: transparent;
}

[data-bs-theme=dark] .nav-tabs-profile .nav-link.active {
    color: var(--bs-success);
    border-bottom-color: var(--bs-success);
}

.profile-avatar-top :deep(img.avatar-xl) {
    width: 100px !important;
    height: 100px !important;
    border: 5px solid var(--bs-light);
}

/* Em ChatProfileSidebar.vue -> <style scoped> (no final) */

.accordion-item {
    background-color: transparent;
    border: none;
    border-radius: 1rem;
    /* Borda totalmente arredondada */
    overflow: hidden;
}

.accordion-button {
    font-weight: 500;
    font-size: 0.9rem;
    color: var(--bs-text-muted);
    background-color: transparent;
    box-shadow: none !important;
    padding: 1.25rem;
    border-radius: 1rem 1rem 0 0 !important;
}

.accordion-button:not(.collapsed) {
    color: var(--bs-dark);
}

.accordion-button::after {
    filter: grayscale(1) opacity(0.5);
}

.favorites-list {
    display: flex;
    flex-direction: column;
    gap: 1px;
    max-height: 250px;
    overflow-y: auto;
    border-radius: 0 0 1rem 1rem;
    margin-top: 0.6rem;
    margin-bottom: 0.6rem;

}

/* Item individual da lista */
.favorite-message-item {
    background: var(--bs-light);
    padding: 12px 1.25rem;
    cursor: pointer;
    transition: background-color 0.15s ease;
    border-radius: 2rem;
    margin: 0.28rem 1rem;
    box-shadow: var(--bs-box-shadow);

}

.favorite-message-item:hover {
    background-color: rgba(var(--bs-primary-rgb), 0.08) !important;
}

/* Nome do Remetente */
.favorite-message-item .sender-name {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 4px;
    display: block;
}

.favorite-message-item .sender-name.you {
    color: var(--bs-success);
}

.favorite-message-item .sender-name.contact {
    color: var(--brand-sender-name-contact-color);
}



.favorite-message-item .snippet {
    font-size: 14px;
    color: var(--bs-dark);
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.favorite-message-item .snippet i {
    margin-right: 4px;
}

.favorite-message-item .timestamp {
    font-size: 11px;
    color: var(--bs-text-muted);
    font-weight: 500;
}

.empty-favorites {
    padding: 1.5rem;
    text-align: center;
    color: var(--bs-text-muted);
    font-size: 14px;
    background: var(--bs-white);
}

[data-bs-theme=dark] .empty-favorites {
    background: var(--bs-body-tertiary);
}

.accordion-header {
    border-radius: 1rem !important;
}

.accordion-button:focus {
    border: none;
    border-color: transparent;
}

.rounded {
    border-radius: 1rem !important;
}




.avatar-wrapper {
    display: inline-block;
    position: relative;
    cursor: pointer;
}

.avatar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 24px;
    opacity: 0;
    transition: opacity 0.2s;
}

.avatar-wrapper:hover .avatar-overlay {
    opacity: 1;
}


/* --- 2. Modo de Edição de Contato --- */
.btn-edit.active {
    color: var(--bs-primary);
    background-color: rgba(var(--bs-primary-rgb), 0.1);
}

.edit-contact-form input {
    font-size: 0.9rem;
}


/* --- 3. Troca de Atendente (Dropdown) --- */
.attendant-change-wrapper {
    background: var(--bs-light);
    padding: 10px;
    border-radius: 8px;
    border: 1px solid var(--bs-border-color);
    margin-top: 10px;
}

[data-bs-theme="dark"] .attendant-change-wrapper {
    background: var(--bs-body-bg);
    border-color: var(--bs-border-color);
}


/* --- 4. Etiquetas (Botão Adicionar e Badges) --- */
.tag-badge {
    padding: 5px 10px;
    border-radius: 6px;
    font-weight: 500;
    border: 1px solid transparent;
    font-size: 0.75rem;
}

.btn-icon-sm {
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid var(--bs-border-color);
    color: var(--bs-text-muted);
    background: transparent;
    transition: all 0.2s;
}

.btn-icon-sm:hover {
    background-color: var(--bs-primary);
    color: #fff;
    border-color: var(--bs-primary);
}


/* --- 5. Observações (Textarea específico) --- */
.form-control.obs-textarea {
    resize: none;
    font-size: 0.9rem;
    background-color: var(--bs-light);
    border: 1px solid transparent;
}

.form-control.obs-textarea:focus {
    background-color: var(--bs-white);
    border-color: var(--bs-primary);
    box-shadow: none;
}

[data-bs-theme="dark"] .form-control.obs-textarea {
    background-color: #2a2d31;
    /* Ajuste para tema escuro */
}


/* --- 6. Abas e Grid de Mídia/Docs/Links --- */

/* Estilo das Abas */
.nav-tabs-profile {
    border-bottom: 1px solid var(--bs-border-color);
    margin-bottom: 0;
}

.nav-tabs-profile .nav-link {
    border: none;
    font-size: 0.85rem;
    color: var(--bs-text-muted);
    padding: 10px 0;
    position: relative;
    background: transparent;
    cursor: pointer;
}

.nav-tabs-profile .nav-link.active {
    color: var(--bs-primary);
    font-weight: 600;
}

.nav-tabs-profile .nav-link.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--bs-primary);
}

/* Área de Rolagem do Conteúdo das Abas */
.tab-content-scrollable {
    max-height: 280px;
    overflow-y: auto;
    padding: 0 !important;
}

/* Grid de Imagens (Mídia) */
.media-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
    padding: 10px;
}

.media-item {
    aspect-ratio: 1;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    background: var(--bs-light);
    position: relative;
}

.media-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
}

.media-item:hover img {
    transform: scale(1.05);
}

.audio-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9ecef;
    color: #6c757d;
}

.video-placeholder {
    width: 100%;
    height: 100%;
    position: relative;
}

.video-placeholder video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
}

.media-item:hover .video-placeholder video {
    transform: scale(1.05);
}

.video-play-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 16px;
    pointer-events: none;
}

/* Listas de Documentos e Links */
.docs-list,
.links-list {
    display: flex;
    flex-direction: column;
}

.doc-item,
.link-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid var(--bs-border-color);
    gap: 10px;
}

.doc-item:last-child,
.link-item:last-child {
    border-bottom: none;
}

.doc-icon,
.link-icon {
    width: 36px;
    height: 36px;
    background: rgba(var(--bs-primary-rgb), 0.1);
    color: var(--bs-primary);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.link-icon {
    background: rgba(var(--bs-info-rgb), 0.1);
    color: var(--bs-info);
}

.doc-info,
.link-info {
    flex: 1;
    overflow: hidden;
}

.doc-download {
    color: var(--bs-text-muted);
    font-size: 18px;
    padding: 4px;
    cursor: pointer;
}

.doc-download:hover {
    color: var(--bs-primary);
}

.bg-success-subtle {
    background-color: rgba(var(--bs-success-rgb), 0.1);
}

.text-success {
    color: var(--bs-success) !important;
}

/* --- Animação de Troca de Perfil --- */
.profile-fade-enter-active,
.profile-fade-leave-active {
    transition: all 0.2s ease-in-out;
}

.profile-fade-enter-from {
    opacity: 0;
    transform: translateX(10px); /* Entra vindo levemente da direita */
}

.profile-fade-leave-to {
    opacity: 0;
    transform: translateX(-10px); /* Sai indo levemente para esquerda */
}

/* Garante que o loading também obedeça a transição suave */
.profile-fade-enter-active .spinner-border,
.profile-fade-leave-active .spinner-border {
    transition: opacity 0.2s;
}

.custom-ddi-dropdown {
    width: 250px;
    max-height: 250px;
    overflow-y: auto;
    border-radius: 12px;
    padding: 8px;
    margin-top: 4px !important;
}
.custom-ddi-dropdown .dropdown-item {
    border-radius: 8px;
    margin-bottom: 2px;
}
.custom-ddi-dropdown .dropdown-item:hover {
    background-color: var(--bs-light);
}

/* --- UI/UX Premium para Área de Edição --- */
.edit-contact-form-wrapper {
    animation: fadeIn 0.2s ease-out;
}
.edit-card {
    background-color: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 6px 16px rgba(0,0,0,0.04);
}
[data-bs-theme="dark"] .edit-card {
    background-color: var(--bs-body-tertiary);
}

.input-label-mini {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--bs-gray-500);
    margin-bottom: 6px;
    display: block;
}

.input-box {
    position: relative;
}
.box-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--bs-gray-400);
    font-size: 16px;
    z-index: 2;
}

.modern-input {
    background-color: var(--bs-light);
    border: 1px solid transparent;
    border-radius: 10px;
    padding-left: 14px; /* Default */
    height: 44px;
    font-size: 14px;
    font-weight: 500;
    color: var(--bs-body-color);
    transition: all 0.2s;
}

.modern-input.ps-5 {
    padding-left: 38px !important;
}

.modern-input:focus {
    background-color: var(--bs-body-bg);
    border-color: var(--bs-primary);
    box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.1);
}

[data-bs-theme="dark"] .modern-input {
    background-color: rgba(255, 255, 255, 0.03);
    border-color: rgba(255, 255, 255, 0.05);
}
[data-bs-theme="dark"] .modern-input:focus {
    background-color: var(--bs-body-bg);
    border-color: var(--bs-primary);
}

.ddi-dropdown-wrapper {
    width: 105px;
    flex-shrink: 0;
}
.ddi-dropdown-wrapper .modern-input {
    padding-left: 10px !important;
    background-color: var(--bs-light);
}

.ddi-flag-img-sm {
    width: 18px;
    height: 13px;
    object-fit: cover;
    border-radius: 2px;
}

.btn-save-modern {
    background: linear-gradient(135deg, var(--bs-primary), var(--brand-primary-dark));
    color: white;
    border: none;
    border-radius: 10px;
    height: 44px;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}
.btn-save-modern:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(var(--bs-primary-rgb), 0.2);
    color: white;
}

.letter-spacing-1 {
    letter-spacing: 0.5px;
}

.custom-switch:checked {
    background-color: var(--bs-primary); border-color: var(--bs-primary);
}

.btn-light {
    border: 1px solid var(--bs-border-color);
}
[data-bs-theme=dark] .btn-light {
    border: 1px solid #404a55;
    color: var(--bs-light-text-emphasis);
}
.bg-light{
    background: var(--bs-light) !important;
}

.dropdown-header-v {
    font-size: 11px;
    font-weight: 800;
    padding: 10px 16px 5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background-color: var(--bs-light);
}

.custom-scrollbar {
    overflow-y: auto;
    margin-right: 2px;
}
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e7eaee; border-radius: 4px; }
[data-bs-theme="dark"] .custom-scrollbar::-webkit-scrollbar-thumb { background: #3b4045; }

.filter-dropdown-content {
    max-height: 450px;
    width: 300px;
    padding: 8px 0;
}

.px-2 {
    padding-right: .7rem !important;
    padding-left: .7rem !important;
}

.tiny-avatar-container {
    display: flex;
    align-items: flex-end;
    padding-bottom: 2px;
    z-index: 1;
}

.tiny-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;

    background: var(--bs-sidebar-bg);
    padding: 1px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* Ajustes para o Dropdown no Modo Noite */
[data-bs-theme="dark"] .custom-ddi-dropdown {
    background-color: #1e293b !important; /* Cor de fundo escura */
    border: 1px solid #334155 !important;
}

[data-bs-theme="dark"] .custom-ddi-dropdown .dropdown-item {
    color: #f1f5f9 !important;
}

[data-bs-theme="dark"] .custom-ddi-dropdown .dropdown-item:hover {
    background-color: #334155 !important;
}

/* Garante que o texto do país selecionado fique visível */
[data-bs-theme="dark"] .text-dark {
    color: #f1f5f9 !important;
}

/* Estilo do scroll para não ficar feio na lista longa */
.custom-scrollbar::-webkit-scrollbar {
    width: 5px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

.select-all-row {
    border-bottom: 1px solid var(--bs-border-color);
    margin-bottom: 4px;
    padding-bottom: 4px;
}

.select-all-row .form-check-label {
    font-size: 12px;
    color: var(--bs-body-color);
}

</style>
